/**
 * en-GB messages added by Phase 4 task W25 (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const w25EnGB = {
    'partner.overview.title': 'Overview',
    'partner.overview.description': 'A quick picture of this customer today.',
    'partner.overview.sites': 'Sites',
    'partner.overview.kiosks': 'Kiosks',
    'partner.overview.kiosksOffline': 'Kiosks offline',
    'partner.overview.users': 'Users',
    'partner.overview.health': 'Health',
    'partner.overview.restriction': 'Billing restriction',
    'partner.overview.usage': 'Usage this month',
    'partner.overview.domains': 'Domains',
    'partner.overview.noDomains': 'No custom domains.',
    'partner.overview.supportAllowed': 'Support access allowed by the customer',
    'partner.overview.yes': 'Yes',
    'partner.overview.no': 'No',
    'partner.restriction.none': 'None',
    'partner.restriction.kiosk_grace': 'Kiosks in grace period',
    'partner.restriction.read_only': 'Read only',
    'partner.health.ok': 'Healthy',
    'partner.health.warning': 'Needs a look',
    'partner.health.problem': 'Problem',
    'partner.usage.sites': 'Sites',
    'partner.usage.ai_questions': 'AI questions',
    'partner.support.title': 'Support session',
    'partner.support.description': 'Sign in to this customer’s portal to help them. The customer’s administrators are told, and everything you do is recorded in their audit log.',
    'partner.support.reason': 'Reason',
    'partner.support.reasonHint': 'At least 5 characters. The customer can see this.',
    'partner.support.minutes': 'Minutes',
    'partner.support.minutesHint': 'Between 5 and 240. The platform limit may shorten it.',
    'partner.support.start': 'Start support session',
    'partner.support.unavailable': 'Support access is not available. The customer has not allowed it, or the customer is not active.',
    'partner.export.title': 'Export all data',
    'partner.export.description': 'Makes a ZIP with every record and file this customer holds. The download link is kept for a limited time.',
    'partner.export.request': 'Request export',
    'partner.export.status.queued': 'Queued',
    'partner.export.status.running': 'Being prepared',
    'partner.export.status.ready': 'Ready',
    'partner.export.status.failed': 'Failed',
    'partner.export.status.expired': 'Expired',
    'partner.export.requested': 'Requested {when}',
    'partner.export.expires': 'Available until {when}',
    'partner.export.size': 'Size {size}',
    'partner.export.download': 'Download export',
    'partner.export.refresh': 'Get a new link',
    'partner.closure.title': 'Close this customer',
    'partner.closure.description': 'Suspends the customer at once, makes an export, and deletes all their data after the notice period. It cannot be undone once the date passes.',
    'partner.closure.pending': 'Closure booked. All data will be deleted after {when}.',
    'partner.closure.cancel': 'Cancel closure',
    'partner.closure.cancelled': 'Closure cancelled.',
    'partner.closure.confirmSlug': 'Type the customer’s short name ({slug}) to confirm',
    'partner.closure.reason': 'Reason for closing',
    'partner.closure.noticeDays': 'Notice period (days)',
    'partner.closure.noticeHint': 'Leave empty for the platform default. Never shorter than 7.',
    'partner.closure.start': 'Close this customer',
    'partner.closure.booked': 'Closure booked.',
    'partner.domains.title': 'Domains',
    'partner.domains.description': 'Custom domains for every customer.',
    'partner.domains.search': 'Search by hostname or customer',
    'partner.domains.hostname': 'Hostname',
    'partner.domains.customer': 'Customer',
    'partner.domains.kind': 'Type',
    'partner.domains.kind.subdomain': 'Subdomain',
    'partner.domains.kind.custom': 'Custom',
    'partner.domains.status.pending_dns': 'Waiting for DNS',
    'partner.domains.status.verified': 'Verified',
    'partner.domains.status.failed': 'Check failed',
    'partner.domains.status.disabled': 'Disabled',
    'partner.domains.disable': 'Disable',
    'partner.domains.disableFor': 'Disable {hostname}',
    'partner.domains.disabled': '{hostname} disabled.',
    'partner.domains.filterStatus': 'Status',
    'partner.domains.any': 'Any',
    'partner.domains.primary': 'Primary',
    'partner.domains.sort': 'Sort by',
};
//# sourceMappingURL=w25.js.map